import React from 'react';
import { DialogV2 } from '@withjoy/joykit';
import { PendingPayoutDialog } from './PendingTransfer';
import { StatusPayoutDialog } from './TransferStatus';
import { CommerceMonetaryValue } from '../CreditCardSetUp.context';

interface PayoutDialogProps {
  isOpen: boolean;
  onClose: () => void;
  isPayoutAllowed: boolean;
  availableBalance?: CommerceMonetaryValue | null;
  fetchPayoutInfo: () => void;
  status: PayoutStatus;
  withdrawBalance: () => void;
  loadingPayoutRequest: boolean;
  accountNumber: string;
}

export type PayoutStatus = 'pending' | 'success' | 'error';
export const PayoutDialog: React.FC<PayoutDialogProps> = ({ onClose, isOpen, isPayoutAllowed, availableBalance, status, loadingPayoutRequest, withdrawBalance, accountNumber }) => {
  return (
    <DialogV2 onClose={onClose} isOpen={isOpen} size="lg">
      <DialogV2.CloseButton />
      <DialogV2.Body marginX={7} marginY={8}>
        {status === 'pending' && (
          <PendingPayoutDialog
            onClose={onClose}
            isPayoutAllowed={isPayoutAllowed}
            loadingPayoutRequest={loadingPayoutRequest}
            withdrawBalance={withdrawBalance}
            availableBalance={availableBalance}
            accountNumber={accountNumber}
          />
        )}
        {status !== 'pending' && <StatusPayoutDialog onClose={onClose} status={status} />}
      </DialogV2.Body>
    </DialogV2>
  );
};
